(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('[data-copy-link]').forEach((btn) => {
    const label = btn.textContent;
    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(location.href);
        btn.textContent = btn.dataset.copied;
        setTimeout(() => { btn.textContent = label; }, 2000);
      } catch (e) { /* clipboard unavailable */ }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || typeof drawer.showModal !== 'function') return;
    const sectionId = drawer.dataset.sectionId;
    const open = () => { if (!drawer.open) drawer.showModal(); };
    const close = () => { if (drawer.open) drawer.close(); };

    const syncHeader = () => {
      const count = parseInt(drawer.querySelector('[data-cart-drawer-panel]')?.dataset.count || '0', 10);
      document.querySelectorAll('.header__cart-count').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
      document.querySelectorAll('.header__cart').forEach((a) => {
        const label = a.getAttribute('aria-label') || '';
        a.setAttribute('aria-label', label.replace(/\(\d+\)/, `(${count})`));
      });
    };
    const render = (html) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-panel]');
      const current = drawer.querySelector('[data-cart-drawer-panel]');
      if (fresh && current) { current.replaceWith(fresh); bind(); syncHeader(); }
    };
    const busy = (on) => drawer.classList.toggle('is-busy', on);

    const change = async (line, quantity) => {
      busy(true);
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: sectionId }),
        });
        const data = await res.json();
        render(data.sections && data.sections[sectionId]);
      } catch (e) { window.location.href = '/cart'; }
      finally { busy(false); }
    };

    const showError = (form, message) => {
      let el = form.querySelector('[data-add-error]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'form-errors';
        el.setAttribute('data-add-error', '');
        el.setAttribute('role', 'alert');
        form.appendChild(el);
      }
      el.textContent = message;
    };

    const add = async (body, form, button) => {
      body.append('sections', sectionId);
      if (button) button.disabled = true;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
        const data = await res.json();
        if (!res.ok) { if (form) showError(form, data.description || data.message || 'Could not add to cart'); return; }
        form?.querySelector('[data-add-error]')?.remove();
        render(data.sections && data.sections[sectionId]);
        open();
      } catch (e) {
        if (form) form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    };

    function bind() {
      drawer.querySelectorAll('[data-cart-close]').forEach((b) => { b.onclick = close; });
      drawer.querySelectorAll('[data-qty-change]').forEach((b) => {
        b.onclick = () => {
          const input = b.parentElement.querySelector('[data-qty-input]');
          const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyChange, 10));
          change(parseInt(b.dataset.line, 10), next);
        };
      });
      drawer.querySelectorAll('[data-qty-input]').forEach((i) => {
        i.onchange = () => change(parseInt(i.dataset.line, 10), Math.max(0, parseInt(i.value, 10) || 0));
      });
      drawer.querySelectorAll('[data-remove]').forEach((b) => { b.onclick = () => change(parseInt(b.dataset.line, 10), 0); });
    }
    bind();
    drawer.addEventListener('click', (e) => { if (e.target === drawer) close(); });

    // The header bag opens the drawer instead of leaving the page
    document.querySelectorAll('.header__cart').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(); }));

    // Product forms add in place
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action) || form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      const button = form.querySelector('[type="submit"]:not([name="checkout"])');
      add(new FormData(form), form, button);
    });

    // Quick add from product cards
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-quick-add]');
      if (!b) return;
      e.preventDefault();
      const fd = new FormData();
      fd.append('id', b.dataset.quickAdd);
      fd.append('quantity', '1');
      add(fd, null, b);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-filter-form]');
    if (!form) return;
    const sort = form.querySelector('[data-sort-select]');
    if (sort) sort.addEventListener('change', () => form.submit());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach((root) => {
    const raw = (root.dataset.date || '').trim().replace(' ', 'T');
    const target = Date.parse(raw);
    const clock = root.querySelector('[data-clock]');
    const ended = root.querySelector('[data-ended]');
    if (!clock || Number.isNaN(target)) return;
    const el = {
      d: root.querySelector('[data-days]'),
      h: root.querySelector('[data-hours]'),
      m: root.querySelector('[data-minutes]'),
      s: root.querySelector('[data-seconds]'),
    };
    const pad = (n) => String(n).padStart(2, '0');
    const set = (node, value) => {
      if (!node || node.textContent === value) return;
      node.textContent = value;
      node.classList.remove('is-flipping');
      void node.offsetWidth;
      node.classList.add('is-flipping');
    };
    let timer;
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        clock.hidden = true;
        if (ended) ended.hidden = false;
        clearInterval(timer);
        return;
      }
      set(el.d, pad(Math.floor(diff / 864e5)));
      set(el.h, pad(Math.floor(diff / 36e5) % 24));
      set(el.m, pad(Math.floor(diff / 6e4) % 60));
      set(el.s, pad(Math.floor(diff / 1e3) % 60));
    };
    tick();
    timer = setInterval(tick, root.hasAttribute('data-no-seconds') ? 30000 : 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-film"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-film]').forEach((root) => {
    const btn = root.querySelector('[data-film-play]');
    const tpl = root.querySelector('template');
    if (!btn || !tpl) return;
    btn.addEventListener('click', () => {
      const frame = tpl.content.firstElementChild;
      if (frame) btn.replaceWith(frame.cloneNode(true));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach((root) => {
    const dialog = root.querySelector('[data-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const buttons = Array.from(root.querySelectorAll('[data-gallery-open]'));
    if (!buttons.length) return;
    const items = buttons.map((b) => ({
      src: b.dataset.full,
      alt: b.querySelector('img')?.alt || '',
      caption: b.dataset.caption || ''
    }));
    const img = dialog.querySelector('[data-lightbox-image]');
    const cap = dialog.querySelector('[data-lightbox-caption]');
    let index = 0;
    const show = (n) => {
      index = (n + items.length) % items.length;
      img.src = items[index].src;
      img.alt = items[index].alt;
      cap.textContent = items[index].caption;
      cap.hidden = !items[index].caption;
    };
    buttons.forEach((b, n) => b.addEventListener('click', () => { show(n); dialog.showModal(); }));
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => show(index + 1));
    if (items.length < 2) {
      dialog.querySelectorAll('[data-lightbox-prev], [data-lightbox-next]').forEach((b) => { b.hidden = true; });
    }
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-menu-drawer]');
    const openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    openBtn.addEventListener('click', () => drawer.showModal());
    drawer.querySelector('[data-menu-close]')?.addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) drawer.close();
    });
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => drawer.close()));
  })();

  (() => {
    const overlay = document.querySelector('[data-search-overlay]');
    const openBtn = document.querySelector('[data-search-open]');
    if (!overlay || !openBtn) return;
    const input = overlay.querySelector('input[type="search"]');
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      input.focus();
    };
    const close = () => {
      overlay.classList.remove('is-open', 'has-results');
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    // Results as you type: Liquid renders them (section_id=predictive-search)
    // so they share the catalogue voice; one in-flight request at a time.
    const results = overlay.querySelector('[data-predictive]');
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; overlay.classList.remove('has-results'); return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${overlay.dataset.predictiveUrl}?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) return;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const inner = doc.querySelector('[data-predictive-results]');
          results.innerHTML = inner ? inner.outerHTML : '';
          overlay.classList.toggle('has-results', !!inner);
        } catch (e) { /* aborted or offline: the submit still works */ }
      }, 220);
    });
    openBtn.addEventListener('click', open);
    overlay.querySelector('[data-search-close]').addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Auto-fit refinement: the Liquid calc approximates from character count;
  // this measures the real rendered width (any glyphs, any font) and trims
  // the size to fit exactly. Very long names on narrow screens flip to a
  // balanced wrap instead of shrinking into a strapline.
  document.querySelectorAll('.hero__wordmark').forEach((mark) => {
    const box = mark.closest('.hero__content--wordmark');
    const probe = mark.querySelector('.hero__wordmark-outline');
    if (!box || !probe) return;
    const fit = () => {
      mark.classList.remove('hero__wordmark--wrap');
      mark.style.removeProperty('--wordmark-adjust');
      const avail = mark.clientWidth;
      const need = probe.scrollWidth;
      if (!avail || !need) return;
      const ratio = Math.min(1, (avail / need) * 0.995);
      const fitted = parseFloat(getComputedStyle(mark).fontSize) * ratio;
      const words = (probe.textContent || '').trim().split(/\s+/).length;
      // A multi-word name that would end up as a strapline reads better set
      // large over two or three lines; a single long word can only shrink.
      if (fitted < 42 && words > 1) {
        mark.classList.add('hero__wordmark--wrap');
      } else if (ratio < 1) {
        mark.style.setProperty('--wordmark-adjust', ratio.toFixed(4));
      }
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
    let raf;
    addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fit);
    });
  });

  // Background video pause/play (WCAG 2.2.2). Mirrors the real playback
  // state, so a blocked autoplay shows "play" rather than lying.
  document.querySelectorAll('[data-hero-video-toggle]').forEach((btn) => {
    const video = btn.closest('.hero')?.querySelector('.hero__video');
    if (!video) { btn.remove(); return; }
    const sync = () => {
      const paused = video.paused;
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    btn.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });
    sync();
  });

  // Pointer parallax on the wordmark (fine pointers, motion allowed)
  (() => {
    const hero = document.querySelector('.hero--style-wordmark');
    const mark = hero && hero.querySelector('.hero__wordmark');
    if (!mark || !window.matchMedia('(pointer: fine) and (prefers-reduced-motion: no-preference)').matches) return;
    let raf;
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width - 0.5) * 2;
      const y = ((e.clientY - r.top) / r.height - 0.5) * 2;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        mark.style.setProperty('--wm-x', (x * 7).toFixed(1) + 'px');
        mark.style.setProperty('--wm-y', (y * 5).toFixed(1) + 'px');
      });
    });
    hero.addEventListener('pointerleave', () => { mark.style.removeProperty('--wm-x'); mark.style.removeProperty('--wm-y'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-release"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const buttons = document.querySelectorAll('[data-track-play]');
    if (!buttons.length) return;
    const audio = new Audio();
    audio.preload = 'none';
    let current = null;
    const setState = (btn, playing) => {
      btn.setAttribute('aria-pressed', String(playing));
      btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
      btn.closest('.latest-release__track')?.classList.toggle('is-playing', playing);
    };
    buttons.forEach((btn) => btn.addEventListener('click', () => {
      if (current === btn && !audio.paused) { audio.pause(); return; }
      if (current && current !== btn) setState(current, false);
      if (current !== btn) { audio.src = btn.dataset.src; current = btn; }
      audio.play().catch(() => setState(btn, false));
    }));
    audio.addEventListener('play', () => current && setState(current, true));
    audio.addEventListener('pause', () => current && setState(current, false));
    audio.addEventListener('ended', () => current && setState(current, false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.querySelectorAll('select[data-default]').forEach((select) => {
    const def = select.dataset.default;
    if (def) select.value = def;
  });
  document.querySelectorAll('form[data-confirm]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!window.confirm(form.dataset.confirm)) e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const recover = document.getElementById('recover');
  if (recover) {
    const open = () => { recover.open = true; };
    if (location.hash === '#recover') open();
    document.querySelectorAll('[data-recover-link]').forEach((a) => a.addEventListener('click', open));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-marquee-toggle]').forEach((btn) => {
    const band = btn.closest('.marquee');
    if (!band) return;
    btn.addEventListener('click', () => {
      const paused = band.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slider]').forEach((root) => {
    const track = root.querySelector('[data-slide-track]');
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.7, 240);
    root.querySelector('[data-slide-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    root.querySelector('[data-slide-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  // Same measured fit as the homepage wordmark: any name, any font, one line.
  document.querySelectorAll('[data-password-wordmark]').forEach((mark) => {
    const probe = mark.querySelector('.password__wordmark-outline');
    if (!probe) return;
    const fit = () => {
      mark.classList.remove('password__wordmark--wrap');
      mark.style.removeProperty('--wordmark-adjust');
      const avail = mark.clientWidth;
      const need = probe.scrollWidth;
      if (!avail || !need) return;
      const ratio = Math.min(1, (avail / need) * 0.995);
      const fitted = parseFloat(getComputedStyle(mark).fontSize) * ratio;
      const words = (probe.textContent || '').trim().split(/\s+/).length;
      if (fitted < 42 && words > 1) mark.classList.add('password__wordmark--wrap');
      else if (ratio < 1) mark.style.setProperty('--wordmark-adjust', ratio.toFixed(4));
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
    let raf;
    addEventListener('resize', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(fit); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product]');
    if (!root) return;
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const variants = JSON.parse(jsonEl.textContent);
    const controls = [...root.querySelectorAll('[data-option-select], [data-option-radio]')];
    const optionCount = (variants[0] && variants[0].options && variants[0].options.length) || 0;
    const valueAt = (i) => {
      const radio = root.querySelector(`[data-option-radio][data-option-index="${i}"]:checked`);
      if (radio) return radio.value;
      const select = root.querySelector(`[data-option-select][data-option-index="${i}"]`);
      return select ? select.value : null;
    };
    const markAvailability = (chosen) => {
      root.querySelectorAll('[data-option-radio]').forEach((radio) => {
        const i = parseInt(radio.dataset.optionIndex, 10);
        const ok = variants.some((v) => v.available && v.options.every((val, j) => (j === i ? val === radio.value : val === chosen[j])));
        radio.nextElementSibling?.classList.toggle('is-unavailable', !ok);
      });
      root.querySelectorAll('[data-option-group]').forEach((g) => {
        const out = g.querySelector('[data-option-value]');
        if (out) out.textContent = chosen[parseInt(g.dataset.optionIndex, 10)] || '';
      });
    };
    const stickyPrice = root.querySelector('[data-price-sticky]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const priceCurrent = root.querySelector('[data-price-current]');
    const priceCompare = root.querySelector('[data-price-compare]');

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      return currency ? amount + ' ' + currency : amount;
    };

    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      root.querySelectorAll('.product__media-item').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.mediaId === String(mediaId));
      });
      root.querySelectorAll('[data-thumb-for]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.thumbFor === String(mediaId));
      });
    };

    root.querySelectorAll('[data-thumb-for]').forEach((btn) => {
      btn.addEventListener('click', () => activateMedia(btn.dataset.thumbFor));
    });

    const onVariantChange = () => {
      const chosen = Array.from({ length: optionCount }, (_, i) => valueAt(i));
      const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));
      markAvailability(chosen);
      if (!match) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.textSoldOut;
        }
        return;
      }
      idInput.value = match.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(match.price);
      if (priceCompare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceCompare.textContent = formatMoney(match.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldOut;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);
      const edition = root.querySelector('[data-edition]');
      if (edition && typeof match.inventory_quantity === 'number' && match.inventory_management) {
        edition.textContent = edition.dataset.text.replace('__R__', match.inventory_quantity);
      }
      if (stickyAdd) stickyAdd.disabled = !match.available;
      if (match.featured_media) activateMedia(match.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };

    controls.forEach((c) => c.addEventListener('change', onVariantChange));
    if (optionCount) markAvailability(Array.from({ length: optionCount }, (_, i) => valueAt(i)));

    // Sticky add-to-cart: show once the real buy button has scrolled off the
    // top. Position is read on scroll (an observer misses instant jumps that
    // never cross the viewport, e.g. anchor links).
    const sticky = root.querySelector('[data-sticky-atc]');
    const buy = root.querySelector('.product__buy');
    if (sticky && buy) {
      let ticking = false;
      const update = () => {
        ticking = false;
        sticky.hidden = buy.getBoundingClientRect().bottom > 0;
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      update();
    }

    // Lightbox
    const lightbox = root.querySelector('[data-lightbox]');
    if (lightbox && typeof lightbox.showModal === 'function') {
      const slides = [...lightbox.querySelectorAll('[data-zoom-slide]')];
      const counter = lightbox.querySelector('[data-lightbox-counter]');
      let current = 0;
      const pad = (n) => String(n).padStart(2, '0');
      const show = (i) => {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach((sl, j) => {
          sl.hidden = j !== current;
          const near = Math.abs(j - current) <= 1 || Math.abs(j - current) === slides.length - 1;
          if (near) sl.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
        });
        if (counter) counter.textContent = `${pad(current + 1)} / ${pad(slides.length)}`;
      };
      root.querySelectorAll('[data-zoom-open]').forEach((b) => b.addEventListener('click', () => {
        const idx = slides.findIndex((sl) => sl.dataset.zoomSlide === b.dataset.zoomOpen);
        show(Math.max(0, idx));
        lightbox.showModal();
      }));
      lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
      lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(current - 1));
      lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(current + 1));
      lightbox.addEventListener('click', (e) => { if (e.target === lightbox || e.target.hasAttribute('data-lightbox-stage')) lightbox.close(); });
      lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') show(current + 1);
        if (e.key === 'ArrowLeft') show(current - 1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.querySelectorAll('[data-related]').forEach((el) => {
    const url = el.dataset.url;
    if (!url) return;
    const load = () => {
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-related]');
          if (fresh && fresh.querySelector('.product-card')) {
            el.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { io.disconnect(); load(); }
        });
      }, { rootMargin: '400px' });
      io.observe(el);
    } else {
      load();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotify-embed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-spotify-facade]').forEach((facade) => {
    const btn = facade.querySelector('[data-spotify-load]');
    const tpl = facade.querySelector('[data-spotify-template]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', () => {
      facade.replaceChildren(tpl.content.cloneNode(true));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-card]').forEach((card) => {
    const btn = card.querySelector('[data-video-play]');
    const tpl = card.querySelector('template');
    if (!btn || !tpl) return;
    btn.addEventListener('click', () => {
      const frame = tpl.content.firstElementChild;
      if (frame) btn.replaceWith(frame.cloneNode(true));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-takeover"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-takeover]').forEach((root) => {
    const video = root.querySelector('video');
    if (!video) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let userPaused = reduced;
    const toggle = root.querySelector('[data-takeover-pause]');
    const setToggle = (paused) => {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.querySelector('[data-icon-pause]').hidden = paused;
      toggle.querySelector('[data-icon-play]').hidden = !paused;
    };
    if (reduced) {
      video.removeAttribute('autoplay');
      video.pause();
      setToggle(true);
    }
    toggle?.addEventListener('click', () => {
      userPaused = !video.paused;
      if (userPaused) video.pause();
      else video.play().catch(() => {});
      setToggle(userPaused);
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { if (!userPaused) video.play().catch(() => {}); }
          else video.pause();
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
